import { api, AUTH_URL } from './client';

// Get a random trivia challenge
export const getTriviaChallenge = async () => {
  return api.get(`${AUTH_URL}/api/v1/trivia/challenge`);
};

// Submit an answer to a trivia challenge
export const submitTriviaAnswer = async (challengeId, answer) => {
  return api.post(`${AUTH_URL}/api/v1/trivia/answer`, {
    challenge_id: challengeId,
    answer: answer,
  });
};

// Get the user's trivia/unlock status
export const getTriviaStatus = async () => {
  return api.get(`${AUTH_URL}/api/v1/trivia/status`);
};
